<template>
  <div
    class="main-toast"
    :class="[
      `main-toast--${group}`,
      `no-text-${text ? 'false' : 'true'}`
    ]"
  >
    <div class="main-toast__icon-container">
      <img
        v-if="group === 'success'"
        :src="require('@/assets/images/toast/success-subtract.svg')"
        alt="Success"
      >
      <img
        v-else-if="group === 'error'"
        :src="require('@/assets/images/toast/error-subtract.svg')"
        alt="Success"
      >
      <img
        v-else-if="group === 'warning'"
        :src="require('@/assets/images/toast/warning-subtract.svg')"
        alt="Success"
      >
    </div>
    <div class="main-toast__message-container">
      <div
        v-if="title"
        class="main-toast__title"
        data-at-toast-title
      >
        {{ title }}
      </div>
      <div
        v-if="text"
        class="main-toast__text"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainToast',

  props: {
    options: {
      type: Object,
      default () {
        return {}
      },
    },
  },

  computed: {
    title () {
      const {
        title = null,
      } = this.options

      return title
    },

    text () {
      const {
        text = null,
      } = this.options

      return text
    },

    group () {
      const {
        group = 'success',
      } = this.options

      return group
    },
  },
}
</script>

<style lang="scss">
$prefix: 'main-toast';

.Vue-Toastification__toast {
  max-height: unset;
  min-height: unset;
  padding: unset;
  max-width: unset;
  min-width: unset;

  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  background: map-get($colors, 'white');

  width: unset !important;
  margin: 0 0.08rem 0.08rem 0.08rem;
}

.Vue-Toastification__container.top-center {
  top: 0.08rem;
  padding-top: 0;
}

.#{$prefix} {
  display: flex;
  flex-direction: row;
  max-width: max-content;
  padding: 0.2rem;

  &.no-text-true {
    align-items: center;
  }

  &--info {}
  &--success {}
  &--warning {}
  &--error {}
}

.#{$prefix}__icon-container {
  display: flex;
  margin-right: 0.16rem;

  img {
    width: 0.32rem;
    height: 0.32rem;
  }
}
.#{$prefix}__message-container {
  width: calc(100% - 0.16rem - 0.32rem);
  white-space: pre-line;
}

.#{$prefix}__title {
  @include typography('h3', 'bold');
  font-style: normal;
  letter-spacing: 0.15000000596046448px;
  text-align: left;

  color: map-get($colors, 'black');

  margin-bottom: 0.04rem;
  .no-text-true & {
    margin-bottom: 0;
  }

}
.#{$prefix}__text {
  @include typography('b2', 'medium');
  color: map-get($colors, 'grey_80');
}
</style>
